(function () {
  const htmlLang = document.documentElement.getAttribute('lang') || '';
  const path = globalThis.location.pathname.replace(/\/+$/, '');

  if (!/^fr\b/i.test(htmlLang) || !/^(\/fr)?\/pages\/vacuslim$/.test(path)) {
    return;
  }

  const translations = [
    ['View Professional Sets', 'Voir les ensembles professionnels'],
    ['One Professional System. Visible Body Contouring Results.', 'Un système professionnel. Des résultats visibles de remodelage corporel.'],
    ['Structured body contouring for measurable aesthetic improvements.', 'Un remodelage corporel structuré pour des améliorations esthétiques mesurables.'],
    ['Vacuslim 48 is a professional Sculpt & Remodeling System designed for salons that want visible, measurable body contour changes without devices and without forcing the body.', 'Vacuslim 48 est un système professionnel de sculpture et de remodelage conçu pour les instituts qui souhaitent obtenir des changements corporels visibles et mesurables, sans appareils et sans forcer le corps.'],
    ['Visible and measurable improvements are often observed from the first treatment and continue progressively throughout the treatment series.', 'Des améliorations visibles et mesurables sont souvent observées dès le premier soin et se poursuivent progressivement tout au long du programme.'],
    ['GET PROFESSIONAL ACCESS', 'OBTENIR L\'ACCÈS PROFESSIONNEL'],
    ['VIEW PROFESSIONAL SETS', 'VOIR LES ENSEMBLES PROFESSIONNELS'],
    ['Why Professional Access? Unlock special offers, trainings and guides with Professional Access', 'Pourquoi l\'accès professionnel ? Débloquez des offres spéciales, des formations et des guides avec l\'accès professionnel.'],
    ['Trusted by professional salons worldwide.', 'Approuvé par des instituts professionnels dans le monde entier.'],
    ['OVER 10,000 PROFESSIONALS HAVE CHOSEN VACUSLIM 48', 'PLUS DE 10 000 PROFESSIONNELS ONT CHOISI VACUSLIM 48'],
    ['CELLULITE', 'CELLULITE'],
    ['Visible reduction in the appearance of cellulite', 'Réduction visible de l\'apparence de la cellulite'],
    ['SCULPT & CONTOUR', 'SCULPTER & REDESSINER'],
    ['Professional body sculpting and contouring results', 'Résultats professionnels de sculpture et de remodelage corporel'],
    ['PROOF & TRUST', 'PREUVES & CONFIANCE'],
    ['PREUVE & CONFIANCE', 'PREUVES & CONFIANCE'],
    ['Proven results backed by professional testimonials', 'Résultats prouvés par des témoignages professionnels'],
    ['What is Vacuslim 48', 'Qu\'est-ce que Vacuslim 48 ?'],
    ['Vacuslim 48 is a Sculpt & Remodeling System based on smart, controlled natural body activation.', 'Vacuslim 48 est un système de sculpture et de remodelage basé sur une activation corporelle naturelle, intelligente et contrôlée.'],
    ['Vacuslim 48 est un système Sculpt & Remodeling basé sur une activation naturelle du corps intelligente et contrôlée.', 'Vacuslim 48 est un système de sculpture et de remodelage basé sur une activation corporelle naturelle, intelligente et contrôlée.'],
    ['Through SmartSculpt™ Technology, which combines specialized active formulations with a controlled vacuum environment, the system supports visible body contouring, improved definition, and smoother-looking skin.', 'Grâce à la technologie SmartSculpt™, qui associe des formules actives spécialisées à un environnement sous vide contrôlé, le système favorise un remodelage visible de la silhouette, une meilleure définition et une peau d\'apparence plus lisse.'],
    ['No forcing', 'Sans contrainte'],
    ['No aggressive techniques', 'Sans techniques agressives'],
    ['Controlled activation', 'Activation contrôlée'],
    ['Repeatable professional process', 'Protocole professionnel reproductible'],
    ['Why Salons Choose Vacuslim 48 ?', 'Pourquoi les instituts choisissent Vacuslim 48 ?'],
    ['Clear results clients can see and measure', 'Des résultats clairs que les clientes peuvent voir et mesurer'],
    ['Easy to sell as a structured program', 'Facile à proposer sous forme de programme structuré'],
    ['Supports repeat bookings', 'Favorise les rendez-vous répétés'],
    ['No devices or complex setup', 'Sans appareils ni installation complexe'],
    ['Fits into everyday salon workflow', 'S\'intègre facilement au quotidien de l\'institut'],
    ['See what our professional partners are seing about the Vacuslim48 impact', 'Découvrez ce que nos partenaires professionnels disent de l\'impact de Vacuslim 48'],
    ['PROFESSIONAL BENEFITS / PROFITABILITY', 'AVANTAGES PROFESSIONNELS / RENTABILITE'],
    ['Vacuslim 48 is designed as a results-driven body treatment that integrates easily into everyday salon workflow and supports structured treatment programs.', 'Vacuslim 48 est conçu comme un soin corps axé sur les résultats, facile à intégrer au fonctionnement quotidien de l\'institut et adapté aux programmes de soins structurés.'],
    ['After completing the first set of 10 treatments, my body shape finally achieved the result I wanted. I am very grateful to my beautician for this system!', 'Après une première série de 10 soins, ma silhouette a enfin atteint le résultat que je souhaitais. Je suis très reconnaissante envers mon esthéticienne pour ce système !'],
    ['Vacuslim 48 is a total game changer for our Spa and Thermal Wellness resort. A must recommendation. After just one session, clients can see significant visible circumference refinement in circumference. In our treatments we use Vacuslim 48 concept and clients are more than satisfied. We have been working together for a long time.', 'Vacuslim 48 a complètement transformé l\'offre de notre spa et centre thermal wellness. C\'est une recommandation incontournable. Dès la première séance, les clientes constatent une réduction visible et significative des mensurations. Nous utilisons le concept Vacuslim 48 dans nos soins et les clientes sont très satisfaites. Nous collaborons depuis longtemps.'],
    ['I have been following Vacuslim 48 since the very first line in 2019, when I first ordered a starter version. I am thrilled with this concept. I use it in my salon and on my body and I really recommend it to everyone. I usually had issues with cellulite and water retention. After 3 sessions I noticed a huge difference in the appearance of my skin.', 'Je suis Vacuslim 48 depuis la toute première gamme en 2019, lorsque j\'ai commandé une première version de démarrage. Je suis ravie de ce concept. Je l\'utilise dans mon institut et sur mon corps, et je le recommande vraiment à tout le monde. J\'avais souvent des problèmes de cellulite et de rétention d\'eau. Après 3 séances, j\'ai remarqué une énorme différence dans l\'apparence de ma peau.'],
    ['My beautician recommended me Vacuslim 48 to try. I have always struggled with volume, loose skin, and cellulite in my thighs and arms area. I went for a 10 treatment program and was surprised at the visible results. It was super easy, relaxing, and the results were noticeable right away.', 'Mon esthéticienne m\'a recommandé d\'essayer Vacuslim 48. J\'ai toujours eu des difficultés avec le volume, le relâchement cutané et la cellulite au niveau des cuisses et des bras. J\'ai suivi un programme de 10 soins et j\'ai été surprise par les résultats visibles. C\'était très simple, relaxant, et les résultats se voyaient tout de suite.'],
    ['Documented visual example after 10 Vacuslim 48 treatments performed according to the professional protocol.', 'Exemple visuel documenté après 10 soins Vacuslim 48 réalisés selon le protocole professionnel.'],
    ['Photographs were taken under consistent conditions, including lighting, body position, and camera distance.', 'Les photos ont été prises dans des conditions constantes, notamment l\'éclairage, la position du corps et la distance de l\'appareil photo.'],
    ['Results reflect an individual outcome and may vary depending on the initial condition, treatment consistency, and lifestyle factors.', 'Les résultats reflètent un cas individuel et peuvent varier selon la condition initiale, la régularité des soins et le mode de vie.'],
    ['They should not be interpreted as guaranteed results.', 'Ils ne doivent pas être interprétés comme des résultats garantis.'],
    ['Note:', 'Remarque :'],
    ['Before & After', 'Avant / Après'],
    ['Choose your Professional Set', 'Choisissez votre set professionnel'],
    ['Choose the system that fits your salon volume and treatment goals.', 'Choisissez le système adapté au volume de votre institut et à vos objectifs de soins.'],
    ['VACUSLIM 48 SMART BOX', 'VACUSLIM 48 SMART BOX'],
    ['VACUSLIM 48 EXPERT BOX', 'VACUSLIM 48 EXPERT BOX'],
    ['START-UP', 'START-UP'],
    ['EXPERT-KIT', 'EXPERT-KIT'],
    ['PROFESSIONAL NON-INVASIVE BODY CARE KIT', 'KIT PROFESSIONNEL NON INVASIF POUR LE CORPS'],
    ['ADVANCED PROFESSIONAL BODY SHAPING KIT', 'KIT PROFESSIONNEL AVANCÉ DE REMODELAGE CORPOREL'],
    ['30 FULL BODY TREATMENTS INCLUDED - 30 body + 20 arm treatments, complete salon solution', '30 SOINS CORPS COMPLETS INCLUS - 30 soins corps + 20 soins bras, une solution complète pour institut'],
    ['30 FULL BODY TREATMENTS INCLUDED', '30 SOINS CORPS COMPLETS INCLUS'],
    ['Ideal for salons introducing professional body contouring — no machines or downtime required.', 'Idéal pour les instituts qui lancent le remodelage corporel professionnel, sans machines ni temps d\'arrêt.'],
    ['UP TO 50 FULL TREATMENT SESSIONS - 50 body treatments, high-volume professional set', 'JUSQU\'À 50 SÉANCES COMPLÈTES - 50 soins corps, ensemble professionnel haute capacité'],
    ['UP TO 50 FULL TREATMENT SESSIONS', 'JUSQU\'À 50 SÉANCES COMPLÈTES'],
    ['Designed for experienced salon professionals ready to elevate their body contouring service menu.', 'Conçu pour les professionnels expérimentés prêts à enrichir leur carte de soins de remodelage corporel.'],
    ['Start working with a structured body contouring system designed for professional consistency and measurable aesthetic improvement.', 'Commencez avec un système de remodelage corporel structuré, conçu pour une constance professionnelle et une amélioration esthétique mesurable.'],
    ['Ready to work with Vacuslim 48', 'Prêt à travailler avec Vacuslim 48'],
    ['Loved by Community', 'Aimé par la communauté'],
    ['follow @vacuslim48', 'suivez @vacuslim48'],
    ['Austria', 'Autriche'],
    ['Croatia', 'Croatie'],
    ['Slovenia', 'Slovénie'],
    ['Serbia', 'Serbie']
  ];

  function translateText(text) {
    let translated = text;

    translations.forEach(function (pair) {
      if (translated.includes(pair[0])) {
        translated = translated.split(pair[0]).join(pair[1]);
      }
    });

    return translated;
  }

  function translateNode(node) {
    if (!node?.nodeValue?.trim()) {
      return;
    }

    const translated = translateText(node.nodeValue);
    if (translated !== node.nodeValue) {
      node.nodeValue = translated;
    }
  }

  function translateTree(root) {
    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          const parent = node.parentNode;
          if (!parent || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT)$/i.test(parent.nodeName)) {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    let textNode = walker.nextNode();
    while (textNode) {
      translateNode(textNode);
      textNode = walker.nextNode();
    }
  }

  function run() {
    const main = document.getElementById('main') || document.body;
    translateTree(main);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'characterData') {
        translateNode(mutation.target);
        return;
      }

      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) {
          translateNode(node);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          translateTree(node);
        }
      });
    });
  });

  observer.observe(document.getElementById('main') || document.body, {
    childList: true,
    characterData: true,
    subtree: true
  });
})();